import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCreditCard1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconCreditCard1"><Path d="M2 6.75293C2 5.23415 3.23122 4.00293 4.75 4.00293H19.248C20.7633 4.00293 21.9945 5.22932 21.9957 6.74653C21.9963 7.51306 21.9962 8.27968 21.9961 9.04593L21.9961 17.2461C21.9961 18.7649 20.7649 19.9961 19.2461 19.9961L4.75 19.9961C3.23122 19.9961 2 18.7649 2 17.2461V10.5H21.9961V9H2V6.75293Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCreditCard1;
